<template>
<div>
    <Breadcrumbs main="Admin" submain="Career" title="Edit Job" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Title</label>
                                        <input class="form-control" type="text" v-model="job.title" placeholder="Enter job title" />
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Vacancy</label>
                                        <input class="form-control" type="number" v-model="job.vacancy" placeholder="Enter job vacancy" />
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Type</label>
                                         <select class="form-control digits" v-model="job.job_type">
                                            <option v-for="(type, index) in types" :key="index" :value="type">{{ type }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Salary</label>
                                        <input class="form-control" type="text" v-model="job.salary_range" placeholder="Enter salary_range range" />
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Location</label>
                                        <input class="form-control" type="text" v-model="job.location" placeholder="Enter job location" />
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Deadline</label>
                                        <input class="form-control" type="date" v-model="job.deadline" placeholder="Enter application deadline" />
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <label>Description</label>
                                        <ckeditor :editor="editor" v-model="job.description" placeholder="Enter job description" />
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <label>Qualification</label>
                                        <ckeditor :editor="editor" v-model="job.qualification" placeholder="Enter qualification" />
                                    </div>
                                </div>
                            </div>
                            <div class="mt-3"> 
                                <b-button @click="handleSubmit">Submit</b-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Container-fluid Ends-->
</div>
</template>

<script>
import { mapState } from 'vuex';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import loader from '../loader/loader.vue';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';

export default {
    components: {
        loader
    },

    data() {
        return {
            editor: ClassicEditor,
            job : {
                title: '',
                vacancy: null,
                deadline: null,
                job_type: 'Full-time',
                salary_range: '',
                location: '',
                description: '',
                qualification: ''
            },
            types: ["Full-time", "Part-time", "Half-time", "Contractual", "Internship"]
        };
    },

    computed: {
        ...mapState({
            new_job: state => state.job.jobDetail,
            loading: state => state.job.jobLoading,
            error: state => state.job.jobError
        })
    },

    watch: {
        new_job(oldValue, newValue) {
            this.job = this.new_job
        }
    },

    mounted() {
        this.$store.dispatch("job/fetchJobDetail", this.$route.params.id).then(() => {
            this.job = this.new_job
        })
    },

    methods: {
        resetModal() {
            this.job.title = null
            this.job.vacancy = null
            this.job.job_type = 'Full-time'
            this.job.salary_range = null
            this.job.location = null
            this.job.deadline = null
            this.job.description = null
            this.job.qualification = null
        },

        handleSubmit() {
            this.$store.dispatch("job/updateJob", {
                id: this.$route.params.id,
                job: this.job
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.resetModal();
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing')
            })
        }
    }
};
</script>
